//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 12.12.2016.
 */

(function () {

    'use strict';

    angular.module('container.widgets')
        .factory('tableColumnFileSizeFilterService', tableColumnFileSizeFilterService);

    function tableColumnFileSizeFilterService(sortService) {

        let service = {};

        service.filter = data => {

            let filteredItems = data.unfilteredItems.slice();

            // Filter by size range
            if (data.fromSize.bytes != null && data.toSize.bytes != null) {

                filteredItems = filteredItems.filter(item => {
                    return item[data.columnKey] >= data.fromSize.bytes && item[data.columnKey] <= data.toSize.bytes;
                });
            }

            // Filter by size string
            if (data.searchText) {

                filteredItems = filteredItems.filter(item => {
                    return parseInt(item[data.columnKey], 10) == parseInt(data.searchText, 10);
                });
            }

            // Sort by direction
            if (data.column.sortDirection) {
                filteredItems = sortService.sortItemsByFileSize(filteredItems, data.columnKey, data.column.sortDirection);
            }

            data.itemsFiltered(filteredItems);
        };

        return service;
    }
})();